var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('HomeVideo',{attrs:{"source":"https://www.youtube.com/embed/FHs65ptPAFw?controls=0&autoplay=1&playlist=FHs65ptPAFw&loop=1&mute=1"}}),_c('AboutBalkam'),_c('MainActivities'),_c('WhyBalkam')],1)}
var staticRenderFns = []

export { render, staticRenderFns }